import Loading from "../components/Loading";

const Api = {
    post: async function (url, data) {

        let res = [];

        const formData  = new FormData();
        for(const name in data) {
            formData.append(name, data[name]);
        }

        const config = {
            method: 'POST',
            body: formData
        };

        Loading(true);
        res = await fetch(url, config).then(response => {
            Loading(false);
            return response.json();
        }).catch(err => {
            Loading(false);
        });
        
        return res;
        
    },
    postWithoutFormData: async function (url, data) {

        let res = [];

        const config = {
            method: 'POST',
            body: data
        };

        Loading(true);
        res = await fetch(url, config).then(response => {
            Loading(false);
            return response.json();
        }).catch(err => {
            Loading(false);
        });

        return res;

    },
    get: async function (url) {

        let res = [];

        Loading(true);
        res = await fetch(url).then(response => {
            Loading(false);
            return response.json();
        }).catch(err => {
            Loading(false);
        });
        
        return res;
        
    },
};

export default Api